import React, { useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Loader } from './components/Loader';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ExperienceSection } from './components/ExperienceSection';
import { CabinsSection } from './components/CabinsSection';
import { TourSection } from './components/TourSection';
import { MomentsSection } from './components/MomentsSection';
import { FacilitiesSection } from './components/FacilitiesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { HowToArriveSection } from './components/HowToArriveSection';
import { ReservationSection } from './components/ReservationSection';
import { Footer } from './components/Footer';
import { CabinModal } from './components/CabinModal';
import { PrivacyPolicyModal } from './components/PrivacyPolicyModal';
import { WhatsAppButton } from './components/WhatsAppButton';
import { CABINS } from './data/cabins';
export function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [selectedCabinId, setSelectedCabinId] = useState<string | null>(null);
  const [isPrivacyPolicyOpen, setIsPrivacyPolicyOpen] = useState(false);
  const selectedCabin = CABINS.find(c => c.id === selectedCabinId) ?? null;
  useEffect(() => {
    document.body.style.overflow = isLoading ? 'hidden' : '';
  }, [isLoading]);
  return <div className="w-full min-h-screen bg-night" data-id="element-0" data-mp="2zmem63p09c5e">
      <AnimatePresence data-id="element-1" data-mp="33mf25srr5vek">{isLoading && <Loader onFinish={() => setIsLoading(false)} data-id="element-2" data-mp="33nq6put0v76q" />}</AnimatePresence>

      <Navbar data-id="element-3" data-mp="38m1f013o59mu" />
      <Hero data-id="element-4" data-mp="38li7zffk45nl" />
      <ExperienceSection data-id="element-5" data-mp="38kqgafp2ys2l" />
      <CabinsSection onSelectCabin={setSelectedCabinId} data-id="element-6" data-mp="38kglmet3bwqk" />
      <TourSection data-id="element-7" data-mp="3dl4kfmnk9hvc" />
      <MomentsSection data-id="element-8" data-mp="3dlnwimqj5c1g" />
      <FacilitiesSection data-id="element-9" data-mp="3dirtwl3qlz6o" />
      <TestimonialsSection data-id="element-10" data-mp="nvsvh92bsvy2" />
      <HowToArriveSection data-id="element-11" data-mp="nuhged3fk1rn" />
      <ReservationSection data-id="element-12" data-mp="nvaqno1ll9ej" />
      <Footer onOpenPrivacyPolicy={() => setIsPrivacyPolicyOpen(true)} data-id="element-13" data-mp="nxx05t81tyze" />
      
      <CabinModal cabin={selectedCabin} onClose={() => setSelectedCabinId(null)} data-id="element-14" data-mp="swqchiblnjxz" />
      <PrivacyPolicyModal isOpen={isPrivacyPolicyOpen} onClose={() => setIsPrivacyPolicyOpen(false)} data-id="element-15" data-mp="34x3flo0nh5h" />
      <WhatsAppButton data-id="element-16" data-mp="3uc9nq9k74apm" />
    </div>;
}